import { Box ,Image} from '@chakra-ui/react'
import React from 'react'

export default function Dailyperformance() {
  return (
    <Box>
        <Image src="https://assets.website-files.com/5d55f1425cb6b7a18aa77528/60ad55d0b5fc492169126b7a_graphs.png"/>
    </Box>
  )
}
